export default __webpack_public_path__ + "static/media/Gray-Line-Patient.d2ad42d8.svg";